<template>
    <div class="mit-admin-page mit-page">
      <BaseMitLoading class="mit-progress" :show="loadingBuildings" :absolute="true"/>
      <v-container fluid>
          <!-- min-width="0" forces it to be the size of the text -->
          <v-snackbar :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
              <b>{{ status.message }}</b>
        </v-snackbar>
          <v-row>
            <v-col cols="12" class="d-flex">
              <v-card class="mit-info-card" style="width:100%">
                  <v-card-title>Settings</v-card-title>
                  <v-card-subtitle class="caption">Change app settings and default values.</v-card-subtitle>
                  <v-divider></v-divider>

                  <v-card-text>
                      <div v-if="!loadingBuildings" class="pa-10">
                                <v-row no-gutters>
                                    <v-col cols="6" md="3">
                                          <v-card flat class="mx-auto pa-2">
                                              <v-card-title>Buildings</v-card-title>
                                             <v-list>
                                               <!-- <v-subheader>Buildings</v-subheader> -->
                                               <v-list-item-group v-model="selectedBuilding" color="primary" @change="selectBuilding()">
                                                 <v-list-item v-for="(building, i) in buildings" :key="i">
                                                   <v-list-item-icon>
                                                     <v-icon>mdi-office-building-outline</v-icon>
                                                   </v-list-item-icon>
                                                   <v-list-item-content>
                                                     <v-list-item-title v-text="building"></v-list-item-title>
                                                   </v-list-item-content>
                                                 </v-list-item>
                                               </v-list-item-group>
                                             </v-list>

                                          </v-card>
                                    </v-col>
                                    <!-- <v-divider vertical></v-divider> -->
                                    <v-col cols="12" sm="6" md="8">

                                            <BaseMitLoading class="mit-progress" :show="loadingSettings" :useOverlay="false"/>
                                            <!-- <v-form v-if="loadingSettings === false && typeof (selectedBuilding) != 'undefined'" class="pa-2"ref="form"> -->
                                            <div v-if="loadingSettings === false && typeof (selectedBuilding) != 'undefined'" class="pa-2">

                                                <v-tabs v-model="tab" background-color="primary" dark grow>
                                                    <v-tab>Version</v-tab>
                                                    <v-tab>Copy Objects</v-tab>
                                                    <v-tab>Delete Objects</v-tab>
                                                    <v-tab>Copy Name and Desc.</v-tab>
                                                    <v-tab>Add Doors To Spaces</v-tab>
                                                </v-tabs>

                                                <v-tabs-items v-model="tab">
                                                    <v-tab-item>
                                                        <v-card flat outlined>
                                                            <v-card-text>
                                                                Switch the running version of the building.<br>
                                                                <br>This switches everything, spaces and objects. Any changes to objects or spaces will only be reflected in the running version.
                                                                <div v-if="currentBuildingStats" class="pa-3">
                                                                    <h3 class="pb-2">Building Info</h3>
                                                                    <div><b>Created:</b> {{currentBuildingStats.stats.createdDt}}</div>
                                                                    <div><b>Last Upated:</b> {{currentBuildingStats.stats.lastEditDt}}</div>
                                                                    <div><b>Spaces:</b> {{currentBuildingStats.stats.numSpaces}}</div>
                                                                    <div><b>Objects:</b> {{currentBuildingStats.stats.numObjects}}</div>
                                                                    <div><b>Doors:</b> {{currentBuildingStats.stats.numDoors}}</div>
                                                                    <div><b>Windows:</b> {{currentBuildingStats.stats.numWindows}}</div>
                                                                </div>
                                                                <v-select class="pt-5" @change="getBuildingInfo()" v-model="settings.currentVersion" :items="versions" item-text="name" item-value="val" label="Version" ></v-select>
                                                                <v-btn class="mr-4" type="submit"  @click="saveSettings()">Save</v-btn>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-tab-item>
                                                    <v-tab-item>
                                                        <v-card flat outlined>
                                                            <v-card-text>
                                                                Copy Objects from one version to another. <br>This is useful when a new building version is uploaded and the the previous versions objects should be used.
                                                                <br><br><b>WARNING!</b> This will first clear out existing objects in the To version
                                                                <v-select class="pt-5" v-model="copyObjectsFromVersion" :items="versions" item-text="name" item-value="val" label="Copy From" ></v-select>
                                                                <v-select v-model="copyObjectsToVersion" :items="versions" item-text="name" item-value="val" label="Copy To" ></v-select>
                                                                <v-btn class="mr-4" :disabled="!(copyObjectsFromVersion != null && copyObjectsToVersion != null)" type="submit" @click="copyObjects()">Copy</v-btn>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-tab-item>
                                                    <v-tab-item>
                                                        <v-card flat outlined>
                                                            <v-card-text>
                                                                Delete all objects in version.
                                                                <v-select class="pt-5" v-model="deleteFromVersion" :items="versions" item-text="name" item-value="val" label="Delete From" ></v-select>
                                                                <v-btn class="mr-4" :disabled="!(deleteFromVersion != null)" color="red" type="submit" @click="deleteObjects()">Delete</v-btn>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-tab-item>
                                                    <v-tab-item>
                                                        <v-card flat outlined>
                                                            <v-card-text>
                                                                Copy Space, Door and Window names and descriptions<br>
                                                                This will copy the names and descriptions of the From version to the To version.
                                                                <br><br><b>WARNING!</b> Any existing names and descriptions will be overwritten
                                                                <v-select class="pt-5" v-model="copySpaceNamesFromVersion" :items="versions" item-text="name" item-value="val" label="Copy From" ></v-select>
                                                                <v-select v-model="copySpaceNamesToVersion" :items="versions" item-text="name" item-value="val" label="Copy To" ></v-select>
                                                                <v-btn class="mr-4" :disabled="!(copySpaceNamesFromVersion != null && copySpaceNamesToVersion != null)" type="submit" @click="copySpaceNames()">Copy</v-btn>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-tab-item>
                                                    <v-tab-item>
                                                        <v-card flat outlined>
                                                            <v-card-text>
                                                                <div class="text-h6 mb-2">Generate Navigation Room Entrances</div>
                                                                <p>
                                                                    This process evaluates raw architectural door structures and physically associates them with their nearest space. 
                                                                    Doors serving the same room are automatically clustered into a single <b>NAV_ROOM_ENTRANCE</b> node.
                                                                </p>
                                                                
                                                                <v-alert type="warning" dense outlined class="mt-4">
                                                                    <b>WARNING:</b> This may take several minutes for large buildings. Running this will wipe existing automatically generated entrances. Any manual location adjustments made to these specific entrance nodes in the map editor will be lost.
                                                                </v-alert>

                                                                <div v-if="entranceStats" class="pa-4 mt-4 mb-4" style="background-color: #f5f5f5; border: 1px solid #e0e0e0; border-radius: 4px; color: #333;">
                                                                    <h3 class="pb-2">Generation Results</h3>
                                                                    <div><b>Total Spaces Evaluated:</b> {{entranceStats.totalSpaces}}</div>
                                                                    <div><b>Spaces With Assigned Doors:</b> {{entranceStats.spacesWithDoors}}</div>
                                                                    <div><b>Spaces Missing Doors:</b> {{entranceStats.spacesWithoutDoors}}</div>
                                                                    <div><b>Old Entrances Cleared:</b> {{entranceStats.deletedOldEntrances}}</div>
                                                                    <div><b>New Entrances Created:</b> {{entranceStats.insertedNewEntrances}}</div>
                                                                </div>

                                                                <v-text-field
                                                                    v-model="generateEntrancesLevel"
                                                                    label="Specific Floor / Level (Optional)"
                                                                    hint="Leave blank to process the entire building, or enter a specific level like '3' to process just one floor."
                                                                    persistent-hint
                                                                    clearable
                                                                    class="mt-4 mb-4"
                                                                    outlined
                                                                    dense
                                                                    style="max-width: 400px;"
                                                                ></v-text-field>

                                                                <v-btn 
                                                                    class="mt-4" 
                                                                    color="primary" 
                                                                    :loading="loadingEntrances" 
                                                                    :disabled="loadingEntrances"
                                                                    @click="generateEntrances()">
                                                                    Generate Entrances
                                                                </v-btn>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-tab-item>
                                                </v-tabs-items>


                                            <!-- </v-form> -->
                                            </div>
                                    </v-col>
                                </v-row>

                      </div>
                  </v-card-text>

              </v-card>
            </v-col>
          </v-row>
      </v-container>
    </div>
</template>

<script>
  import moment from 'moment';

  import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';
  import MitSpacesSettingsService from '../../services/MitSpacesSettingsService.js';
  import MitSpacesService from '../../services/MitSpacesService.js';

  export default {
    name: 'MitAdminBuildingsSettingsPage',
    components: {
      BaseMitLoading
    },
    data: function() {
      return {
          loadingBuildings:true,
          loadingSettings:false,
          status:{
              display:false,
              timeout:2000,
              message:'Saved!',
              color:'primary'
          },
          //Room entrance params
          loadingEntrances: false,
          entranceStats: null,
          generateEntrancesLevel: null,
          //-----------------
          copyObjectsFromVersion:null,
          copyObjectsToVersion:null,
          deleteFromVersion:null,
          copySpaceNamesFromVersion:null,
          copySpaceNamesToVersion:null,
          settings:{
              id:null,
              currentVersion: null,
              last_edited_dt: null
          },
          tab:null,
          versions:[],
          selectedVersion:null,
          buildings:[],
          selectedBuilding:null,
          currentBuildingStats:null,
          settingsService: new MitSpacesSettingsService()
      }
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    mounted() {
        //get current settings
        MitSpacesService.getBuildingsMitIdUniqueList()
        .then((buildings) => {
            this.loadingBuildings = false;
            this.buildings = buildings;
            //select the first one by default
            if(this.buildings.length > 0){
                this.selectedBuilding = 0;
                this.selectBuilding();
            }
        })
        .catch((error)=>{
            this.loadingBuildings = false;
        })
    },
    methods: {
        generateEntrances() {
          if (typeof(this.selectedBuilding) != 'undefined') {
              let msg = "Warning: This will recalculate physical door coordinates and overwrite any manual adjustments made to NAV_ROOM_ENTRANCE nodes.";
              if (this.generateEntrancesLevel) {
                  msg += `\n\nYou are about to process ONLY floor: ${this.generateEntrancesLevel}`;
              } else {
                  msg += `\n\nYou are about to process the ENTIRE building.`;
              }
              
              if (confirm(msg + "\n\nDo you wish to proceed?")) {
                  this.loadingEntrances = true;
                  this.entranceStats = null;
                  
                  // Pass the optional level to the service
                  MitSpacesService.generateRoomEntrances(this.buildings[this.selectedBuilding], this.generateEntrancesLevel)
                      .then((stats) => {
                          this.loadingEntrances = false;
                          this.entranceStats = stats;
                          this.status.message = 'Successfully generated entrances!';
                          this.status.color = 'primary';
                          this.status.display = true;
                      })
                      .catch((error) => {
                          this.loadingEntrances = false;
                          console.error('Error generating entrances:', error);
                          
                          // Attempt to extract the real backend error message
                          let errorMsg = 'An error occurred during door generation.';
                          if (error.response && error.response.data) {
                              // If Postgres throws an error, it's usually nested in the data object
                              errorMsg = error.response.data.message || error.response.data.error || error.response.data.routine || errorMsg;
                          } else if (error.message) {
                              errorMsg = error.message;
                          }
                          
                          this.status.message = 'Error: ' + errorMsg;
                          this.status.color = 'red';
                          this.status.display = true;
                      });
              }
          }
      },
        getBuildingInfo(){
            if(typeof(this.selectedBuilding) != 'undefined'){
                //get current settings
                MitSpacesService.getBuildingStats(this.buildings[this.selectedBuilding],this.settings.currentVersion)
                .then((buildingStats) => {
                    this.currentBuildingStats = buildingStats;
                    this.currentBuildingStats.stats.createdDt = moment(this.currentBuildingStats.stats.createdDt).local().format('MM/DD/YYYY h:mm:ss a');
                    this.currentBuildingStats.stats.lastEditDt = moment(this.currentBuildingStats.stats.lastEditDt).local().format('MM/DD/YYYY h:mm:ss a');
                })
                .catch((error)=>{
                    console.log('Error trying to get building stats for version')
                });
            }
        },
      saveSettings() {
          if(typeof(this.selectedBuilding) != 'undefined'){
              this.loadingSettings = true;
              this.settingsService.update(this.buildings[this.selectedBuilding], this.settings)
                  .then((buildingSettings) => {
                      this.loadingSettings = false;
                      this.status.message = 'Set Version!'
                      this.status.color = 'primary';
                      this.status.display = true;
                      this.selectBuilding();
                  })
                  .catch((error)=>{
                      this.loadingSettings = false;
                      console.log('Error saving building settings', error);
                      this.status.message = 'An error occurred trying to save.';
                      this.status.display = true;
                      this.status.color = 'red';
                  })
          }
      },
      selectBuilding(){
          //make sure something is selected
          if(typeof(this.selectedBuilding) != 'undefined'){
              this.loadingSettings = true;
              this.currentBuildingStats = null;
              this.settingsService.get(this.buildings[this.selectedBuilding])
                  .then((buildingSettings) => {
                      this.loadingSettings = false;
                      this.settings = buildingSettings.settings;
                      this.versions = buildingSettings.ui.versions;

                      this.getBuildingInfo();
                  })
                  .catch((error)=>{
                      this.loadingSettings = false;
                  })
          }

      },
      copyObjects(){
          if(typeof(this.selectedBuilding) != 'undefined'){
              this.loadingSettings = true;
              MitSpacesService.copyObjects(this.buildings[this.selectedBuilding], this.copyObjectsFromVersion, this.copyObjectsToVersion)
                  .then((copyResults) => {
                      this.loadingSettings = false;
                      this.status.message = 'Successfully copied '+copyResults.numberCopied+' objects!';
                      this.status.color = 'primary';
                      this.status.display = true;
                      this.getBuildingInfo();
                  })
                  .catch((error)=>{
                      this.loadingSettings = false;
                      console.log('Error copying building objects', error);
                      this.status.message = 'An error occurred trying to copy.';
                      this.status.display = true;
                      this.status.color = 'red';
                  })
          }
      },
      deleteObjects(){
          if(typeof(this.selectedBuilding) != 'undefined'){
              this.loadingSettings = true;
              MitSpacesService.deleteObjects(this.buildings[this.selectedBuilding], this.deleteFromVersion)
                  .then((copyResults) => {
                      this.loadingSettings = false;
                      this.status.message = 'Successfully deleted '+copyResults.numberDeleted+' objects.';
                      this.status.color = 'primary';
                      this.status.display = true;
                      this.getBuildingInfo();
                  })
                  .catch((error)=>{
                      this.loadingSettings = false;
                      console.log('Error deleting building objects', error);
                      this.status.message = 'An error occurred trying to delete.';
                      this.status.display = true;
                      this.status.color = 'red';
                  })
          }
      },
      copySpaceNames(){
          if(typeof(this.selectedBuilding) != 'undefined'){
              this.loadingSettings = true;
              MitSpacesService.copySpaceNames(this.buildings[this.selectedBuilding], this.copySpaceNamesFromVersion, this.copySpaceNamesToVersion)
                  .then((copyResults) => {
                      this.loadingSettings = false;
                      this.status.message = 'Successfully copied '+copyResults.numberCopied+' spaces data!';
                      this.status.color = 'primary';
                      this.status.display = true;
                      this.getBuildingInfo();
                  })
                  .catch((error)=>{
                      this.loadingSettings = false;
                      console.log('Error copying space data', error);
                      this.status.message = 'An error occurred trying to copy.';
                      this.status.display = true;
                      this.status.color = 'red';
                  })
          }
      },

    }
  }
</script>

<style lang="scss" scoped>

</style>
